module.exports = __webpack_public_path__ + "img/shuang2.3b38b48d.png";